import { Injectable } from '@angular/core';
import { AuthService } from '@vinnova/auth';
import { Observable } from 'rxjs';
import { BasePersonDetailsService } from './base-person-details.service';
@Injectable({
  providedIn: 'root',
})
export class PersonDetailsService extends BasePersonDetailsService {
  constructor(private authService: AuthService) {
    super();
  }

  /**
   *
   * @returns An observable that emits the personDetails once
   */
  public getPersonDetails$(): Observable<{
    firstName: string;
    lastName: string;
    email: string;
  }> {
    return this.authService.getPersonDetails();
  }
}
